"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZAP_META_ID = void 0;
const core_1 = require("@emotion/core");
const react_1 = require("react");
const lodash_1 = __importDefault(require("lodash"));
const design_system_1 = require("@zapier/design-system");
const MultiSampleDataSubheading_1 = __importDefault(require("../../sample/MultiSampleDataSubheading"));
const SampleDataNerdView_1 = __importDefault(require("../../sample/SampleDataNerdView"));
const useSelectFirstRealSample_1 = __importDefault(require("./useSelectFirstRealSample"));
const Styles = {
    root: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    buttonContainer: {
        marginTop: 30,
        display: 'flex',
        justifyContent: 'flex-end',
    },
};
exports.ZAP_META_ID = '_zap_data_sample_id';
const MultiSamplePicker = (props) => {
    const { authTitle, firstSampleId, hasReceivedFreshSample, isErrored, isSkipped, isTesting, nodeId, noun, onContinue, onSave, onSelectTriggerSample, onTest, samples, selectedTriggerSampleId, service, serviceKey, shouldGoToNextStep, taskStateSelectedSample, webhookUrl, } = props;
    const shouldAutoSelectFirstSample = !lodash_1.default.isEmpty(samples) && !taskStateSelectedSample;
    const noSamplesSelectedInCurrentApp = !samples.find(sample => sample[exports.ZAP_META_ID] === selectedTriggerSampleId);
    const canSelectFirstSample = Boolean(samples.find(sample => sample[exports.ZAP_META_ID] === firstSampleId));
    const onSelectSample = react_1.useCallback(id => {
        onSelectTriggerSample(id);
        onSave(nodeId, { selected_sample_id: id });
    }, [nodeId, onSave, onSelectTriggerSample]);
    react_1.useEffect(() => {
        if (noSamplesSelectedInCurrentApp && canSelectFirstSample) {
            onSelectSample(firstSampleId);
        }
    }, [
        canSelectFirstSample,
        firstSampleId,
        noSamplesSelectedInCurrentApp,
        onSelectSample,
        props,
        shouldAutoSelectFirstSample,
        shouldGoToNextStep,
    ]);
    useSelectFirstRealSample_1.default({
        onSelectSample,
        samples,
        selectedSampleId: selectedTriggerSampleId,
    });
    const selectedSample = samples.find(sample => sample._zap_data_sample_id === selectedTriggerSampleId);
    const onClickContinue = () => onContinue();
    return (core_1.jsx("div", { css: Styles.root },
        !isErrored && (core_1.jsx(MultiSampleDataSubheading_1.default, { actionNoun: noun, authTitle: authTitle, isSkipped: isSkipped, service: service, webhookUrl: webhookUrl })),
        core_1.jsx(SampleDataNerdView_1.default, { isBuiltInApp: service.isBuiltIn, isLoadingMore: isTesting, isUnableToFindMoreEvents: isErrored || !hasReceivedFreshSample, onChange: ({ _zap_data_sample_id: id }) => {
                onSelectSample(id);
            }, onLoadMore: onTest, sampleNoun: noun, samples: samples, selectedApi: serviceKey, value: selectedSample }),
        core_1.jsx("div", { css: Styles.buttonContainer },
            core_1.jsx(design_system_1.Button, { color: "blue", hasShadow: true, isFullWidth: true, onClick: onClickContinue }, "Continue"))));
};
exports.default = MultiSamplePicker;
